import { Timestamp } from 'firebase/firestore';
import type { AvantProjet } from './avantProjet';

// Plus de projet clos/archivé (02/11/2026) : tout projet reste ouvert à la saisie.
export const PROJECT_STATUSES = ['active'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export const PROGRAM_TYPES = [
  'LaunchPad',
  'ScaleUp',
  'UnLock',
  'DiagDesign',
  'DiagEco',
  'DiagAmorcageIndus',
  'Internal',
] as const;
export type ProgramType = (typeof PROGRAM_TYPES)[number];

export interface ProgramPhase {
  type: ProgramType;
  startDate: Timestamp;
  endDate?: Timestamp;
}

export const TEAM_ROLE_KEYS = [
  'managers',
  'rdLead',
  'rdMeca',
  'rdElec',
  'testBench',
  'dft',
  'supplyChain',
  'quality',
  'bizdev',
  'marketing',
  // Ajout automatique : qui a saisi du temps sans être membre (#66). Aucun droit.
  'contributors',
] as const;
export type TeamRoleKey = (typeof TEAM_ROLE_KEYS)[number];

export interface ProjectTeam {
  managers: string[];
  rdLead: string[];
  rdMeca: string[];
  rdElec: string[];
  testBench: string[];
  dft: string[];
  supplyChain: string[];
  quality: string[];
  bizdev: string[];
  marketing: string[];
  /** Absent des projets antérieurs au 2026-10-26 : lire avec `?? []`. */
  contributors?: string[];
}

export function emptyTeam(): ProjectTeam {
  return {
    managers: [],
    rdLead: [],
    rdMeca: [],
    rdElec: [],
    testBench: [],
    dft: [],
    supplyChain: [],
    quality: [],
    bizdev: [],
    marketing: [],
    contributors: [],
  };
}

export function flattenTeam(team: ProjectTeam): string[] {
  return [...new Set(Object.values(team).flat())];
}

export interface Project {
  id: string;
  code: string;
  name: string;
  clientId: string;
  team: ProjectTeam;
  allMemberUids: string[];
  status: ProjectStatus;
  programHistory: ProgramPhase[];
  currentProgram: ProgramType;
  sharepointLink?: string;
  teamsLink?: string;
  customerWebsite?: string;
  photos?: string[];
  /**
   * Présent = ce projet a fait l'objet d'un avant-projet. La PRÉSENCE de la clé
   * tient lieu de case cochée : pas de booléen séparé, qui pourrait contredire
   * son propre contenu.
   */
  avantProjet?: AvantProjet;
  createdBy: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
